import { injectScript } from '@atc/dom-fns';
import _get from 'lodash/get';
import { isQA } from '../../utilities/getEnvironment.js';
import { pathByBrandEnv } from './getPixallPathByBrandEnv';
let pixallLibrary = null;
export default async function getPixall(_temp) {
  let {
    brand = 'atc',
    disablePixall = false
  } = _temp === void 0 ? {} : _temp;
  if (disablePixall) {
    return [];
  }
  if (pixallLibrary) {
    return pixallLibrary;
  }
  let scriptPath = '';
  const env = isQA() ? 'qa' : 'prod';
  scriptPath = _get(pathByBrandEnv, [brand, env], pathByBrandEnv.atc.prod);
  pixallLibrary = Promise.resolve(window.Pixall && window._pxan ? window._pxan : injectScript(scriptPath).then(() => window._pxan));
  return pixallLibrary;
}